import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { FaInstagram, FaLinkedin, FaYoutube } from "react-icons/fa";
import JeevanLogo from "./images/JeevanLogo.svg";


const Footer = () => {
  return (
    <footer className="bg-black text-white py-4 footerhgt">
      <Container>
        <Row className="align-items-center">
          {/* Left Section */}
          <Col md={4} className="mb-3 mb-md-0 footer-column">
            <img src={JeevanLogo} alt="Jeevan Infotech" height="40" className="mb-2" />
            <div className="">Jeevan Infotech</div>
            <p className="mb-2">Pioneer in Apparel & Textile Automation</p>
            <div className="d-flex gap-3 footer-icons">
              <FaInstagram size={20} />
              <FaLinkedin size={20} />
              <FaYoutube size={20} />
            </div>
          </Col>

          {/* Center Section */}
          <Col md={5} className="d-flex justify-content-md-center footer-column">
            <ul className="list-unstyled d-flex gap-4 mb-0">
              <li>
                <strong>Products</strong>
                <ul className="list-unstyled small mt-1">
                  <Link to="/operation360" className="footerlist"><li>Operation 360</li></Link>
                  <Link to="/synergy360" className="footerlist"><li>Synergy 360</li></Link>
                </ul>
              </li>
              <Link to="/pricing" className="footerlist"><li>Pricing</li></Link>
              {/* <Link to="/blogpage" className="footerlist"><li>Blog</li> </Link>  */}
              <Link to="/contactform" className="footerlist"><li>Contact Us</li></Link>
            </ul>
          </Col>

          {/* Right Section */}
          <Col md={3} className="footer-column">
            <Link to="/privacy"><p className="small mb-1 footerprivacy">Privacy Policy</p></Link>
            <Link to="/terms"><p className="small mb-1 footerprivacy">Terms & Conditions</p></Link>
            <p className="small mb-0 allrights">All Rights Reserved.</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;